export default __webpack_public_path__ + "static/PopupBackground1Mobile-c4304b20075559b5c69cac07ddc5dc46.webp";